import * as React from "react";

import { cn } from "@/lib/utils";

const Alert = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn("relative w-full rounded-lg border p-4", className)} {...props} />
  ),
);
Alert.displayName = "Alert";

(Alert as any).Title = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLHeadingElement>>(
  ({ className, children, ...props }, ref) => <h5 ref={ref} className={cn("mb-1 font-medium leading-none", className)} {...props}>{children}</h5>,
);
(Alert as any).Title.displayName = "AlertTitle";

(Alert as any).Description = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn("text-sm", className)} {...props} />,
);
(Alert as any).Description.displayName = "AlertDescription";

export { Alert };
export const AlertTitle = (Alert as any).Title;
export const AlertDescription = (Alert as any).Description;
